<h2 app-landing-page-title i18n="@@ammunition.templates.header">Firearms Assignment Email Templates
</h2>

<app-email-template-parameters [replacementParameters]="replacementParameters">
</app-email-template-parameters>

<mat-card>
  <mat-card-header>
    <mat-card-title i18n="@@ammunition.rangerIssue.header">
      Ammunition - Ranger Issue
    </mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <h2 i18n="@@ammunition-ranger-issue-email-templates.subject">Subject</h2>
    <persistent-simple-text-section-entity section="ammunition.ranger-issue.subject"
      [textTransformer]="textTransformer"></persistent-simple-text-section-entity>
    <br />
    <h2 i18n="@@ammunition-ranger-issue-email-templates.body">Body</h2>
    <persistent-rich-text-section-entity section="ammunition.ranger-issue.body"
      [textTransformer]="textTransformer"></persistent-rich-text-section-entity>
  </mat-card-content>
</mat-card>
